import Svg, { SvgProps } from './Svg';

export default function UpIcon({ color = 'currentColor', ...props }: SvgProps) {
  return (
    <Svg
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}>
      <path d="m18 9-6-6-6 6 M12 3v14 M5 21h14"></path>
    </Svg>
  );
}
